/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getPlatformOrganisationsAddons } from '../fn/platform/get-platform-organisations-addons';
import { GetPlatformOrganisationsAddons$Params } from '../fn/platform/get-platform-organisations-addons';
import { getPlatformOrganisationSitesAddons } from '../fn/platform/get-platform-organisation-sites-addons';
import { GetPlatformOrganisationSitesAddons$Params } from '../fn/platform/get-platform-organisation-sites-addons';
import { OrganizationKeysAndNames } from '../models/organization-keys-and-names';
import { OrganizationSite } from '../models/organization-site';

@Injectable({ providedIn: 'root' })
export class PlatformService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPlatformOrganisationSitesAddons()` */
  static readonly GetPlatformOrganisationSitesAddonsPath = '/platform/organization-sites';

  /**
   * Get all organization sites.
   *
   * Returns all organization sites and their roles.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPlatformOrganisationSitesAddons()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlatformOrganisationSitesAddons$Response(params?: GetPlatformOrganisationSitesAddons$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationSite>>> {
    const obs = getPlatformOrganisationSitesAddons(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all organization sites.
   *
   * Returns all organization sites and their roles.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPlatformOrganisationSitesAddons$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlatformOrganisationSitesAddons(params?: GetPlatformOrganisationSitesAddons$Params, context?: HttpContext): Observable<Array<OrganizationSite>> {
    const resp = this.getPlatformOrganisationSitesAddons$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<OrganizationSite>>): Array<OrganizationSite> => r.body)
    );
  }

  /** Path part for operation `getPlatformOrganisationsAddons()` */
  static readonly GetPlatformOrganisationsAddonsPath = '/platform/organizations';

  /**
   * Get all organizations with their sites.
   *
   * Returns all organizations and their sites.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPlatformOrganisationsAddons()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlatformOrganisationsAddons$Response(params?: GetPlatformOrganisationsAddons$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationKeysAndNames>> {
    const obs = getPlatformOrganisationsAddons(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all organizations with their sites.
   *
   * Returns all organizations and their sites.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPlatformOrganisationsAddons$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlatformOrganisationsAddons(params?: GetPlatformOrganisationsAddons$Params, context?: HttpContext): Observable<OrganizationKeysAndNames> {
    const resp = this.getPlatformOrganisationsAddons$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrganizationKeysAndNames>): OrganizationKeysAndNames => r.body)
    );
  }

}
